import * as React from "react";

import ConferenceRoomBooking from 'src/containers/3d-conferenceRoomBooking/conferenceRoomBooking';

export default () => {
  return <ConferenceRoomBooking />;
}